function mapQuestion(q) {
  return {
    questionId: q.questionId ?? null,
    type: q.type,
    targetTerm: q.targetTerm,
    isCumulative: q.isCumulative ?? false,
    question: q.question,
    options: q.options ?? null,
    wordBank: q.wordBank ?? null,
    matchPairs: q.matchPairs ?? null,
    correctAnswer: q.correctAnswer,
    explanation: q.explanation ?? '',
    deferred: false,
  };
}

export function mapLessonContent(raw) {
  const content = raw.content || raw;
  const metadata = content.metadata || {};
  const termCards = content.termCards || [];
  const phases = content.phases || {};
  const frontloading = phases.frontloading || {};
  const termSequence = phases.termSequence || [];
  const masteryTest = phases.masteryTest || {};
  const guidedNotes = content.guidedNotes || {};

  const termOrder = frontloading.uiHighlightSequence || termCards.map(tc => tc.term);
  const termCardMap = Object.fromEntries(termCards.map(tc => [tc.term, tc]));
  const seqMap = Object.fromEntries(termSequence.map(ts => [ts.term, ts]));

  const terms = termOrder.map(termName => {
    const card = termCardMap[termName] || {};
    const seq = seqMap[termName] || {};
    const wb = seq.workbook || {};
    const kc = seq.knowledgeCheck || {};

    return {
      term: card.term || termName,
      definition: card.definition || '',
      exampleSentence: card.exampleSentence || '',
      relatedTerms: card.relatedTerms || [],
      learning: {
        tutorScript: seq.learning?.tutorScript || '',
      },
      workbook: {
        exerciseLabel: wb.exerciseLabel || '',
        exerciseNumber: wb.exerciseNumber || 0,
        tutorOpenWorkbook: wb.tutorOpenWorkbook || '',
        tutorReadExercise: wb.tutorReadExercise || '',
        tutorPresentOptions: wb.tutorPresentOptions || '',
        exercise: wb.exercise || '',
        options: wb.options || [],
        correctAnswer: wb.correctAnswer || '',
        optionFeedback: wb.optionFeedback || [],
        tutorTransition: wb.tutorTransition || null,
      },
      knowledgeCheck: {
        tutorTransition: kc.tutorTransition ?? wb.tutorTransition ?? null,
        questions: (kc.questions || []).map(mapQuestion),
      },
    };
  });

  return {
    metadata: {
      lessonId: metadata.lessonId || '',
      grade: metadata.grade || 0,
      subject: metadata.subject || '',
      topic: metadata.topic || '',
      lexileLevel: metadata.lexileLevel || '',
      lexileBand: metadata.lexileBand || '',
      estimatedDurationMinutes: metadata.estimatedDurationMinutes || 0,
      keyTermCount: metadata.keyTermCount || 0,
    },
    frontloading: {
      tutorScript: frontloading.tutorScript || '',
      termOrder,
    },
    terms,
    mastery: {
      passingThreshold: masteryTest.passingThreshold ?? 0.8,
      questions: (masteryTest.questions || []).map(mapQuestion),
    },
    guidedNotes: {
      learningObjectives: guidedNotes.learningObjectives || [],
      keyTakeaways: guidedNotes.keyTakeaways || [],
    },
  };
}
